import { useEffect, useState } from 'react'

/**
 * Re-render on an interval so the intra-day countdown actually ticks. The
 * strip's 30s roster refetch can't carry this: react-query's structural
 * sharing keeps `data` referentially stable when the payload is unchanged,
 * so a refetch alone may not re-render.
 */
export function useNow(intervalMs: number): Date {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
